import { NgModule } from '@angular/core';
import { provideLazyLoad } from '@core/jss-utils';
import { CalculateContainerComponent } from '@innogy/become-a-customer/calculate';
import { AcquisitionCommodityOfferContainerComponent } from '@innogy/become-a-customer/offer';
import {
  OrderContainerComponent,
  OrderOverviewEdComponent,
  OrderOverviewEssentComponent,
  OrderOverviewSmeComponent,
} from '@innogy/become-a-customer/order';
import { OfferFAQComponent } from '@innogy/become-a-customer/ui';

@NgModule({
  imports: [
    provideLazyLoad({
      Calculate: CalculateContainerComponent,
      Order: OrderContainerComponent,
      OrderOverviewED: OrderOverviewEdComponent,
      OrderOverviewSME: OrderOverviewSmeComponent,
      OrderOverviewEssent: OrderOverviewEssentComponent,
      AcquisitionCommodityOffer: AcquisitionCommodityOfferContainerComponent,
      OfferFAQ: OfferFAQComponent,
    }),
  ],
})
export class BecomeACustomerLazyModule {}
